var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.714,
    height: 55,
    viewBox: "0 0 47.714 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contact_github",
    d: "M31.856,35.731c1.242,1.081,2.353,3.192,2.353,6.431,0,4.647-.04,8.392-.04,9.537,0,.7.647.881.558,1.326C34.331,55,27.246,55,25.558,55c-1.352,0-8.777-.009-9.171-1.983-.086-.432.56-.6.56-1.318,0-.828-.035-3.566-.046-6.471C7.238,47.333,5.2,41.132,5.2,41.132c-1.576-4.015-3.854-5.085-3.854-5.085-3.152-2.157.236-2.111.236-2.111C5.07,34.184,6.9,37.52,6.9,37.52c3.095,5.309,8.127,3.773,10.106,2.887a7.385,7.385,0,0,1,2.209-4.648C11.5,34.88,3.39,31.9,3.39,18.6A13.445,13.445,0,0,1,6.968,9.273,12.507,12.507,0,0,1,7.307.081s2.916-.938,9.554,3.56a32.816,32.816,0,0,1,17.394,0C40.887-.856,43.8.081,43.8.081a12.488,12.488,0,0,1,.345,9.191A13.414,13.414,0,0,1,47.714,18.6c0,13.339-8.127,16.278-15.858,17.135",
    transform: "translate(0 0)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactGithub);
export default __webpack_public_path__ + "static/media/contact_github.522b03189f92d92b2fd07e77c6cd3540.svg";
export { ForwardRef as ReactComponent };